<div fxLayout="column" class="cipo--height--full">
    <div>
        @if (!options() || !options().hideSearch) {
            <div fxLayoutAlign="space-between center" fxLayout="row wrap" class="m-b-md">
                <ng-content></ng-content>
                <span></span>
                <div fxLayout="row wrap">
                    <mat-form-field class="cipo-input p-0">
                        <mat-label>{{ "general.search" | translate }}</mat-label>
                        <input matInput [formControl]="searchControl" />
                        @if (searchControl.value) {
                            <button
                                matSuffix
                                [title]="'general.clear' | translate"
                                [attr.aria-label]="'general.clear' | translate"
                                mat-icon-button
                                (click)="clearInput()">
                                <mat-icon aria-hidden="true">close</mat-icon>
                            </button>
                        } @else {
                            <mat-icon matSuffix>search</mat-icon>
                        }
                    </mat-form-field>
                    @if (!options() || !options().hideAddNewItem) {
                        <button class="m-l-lg" mat-icon-button (click)="addNewAction.emit()" [attr.aria-label]="'a11y.common.add' | translate">
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">add</mat-icon>
                        </button>
                    }
                    @if (topActions()?.length) {
                        <span>
                            @for (action of topActions(); track $index) {
                                <button
                                    mat-icon-button
                                    [title]="action.label | translate"
                                    [attr.aria-label]="action.label | translate"
                                    (click)="action.action ? action.action() : null"
                                    [matMenuTriggerFor]="action.children?.length ? actionsChildren : null"
                                    [matMenuTriggerData]="{ children: action.children }">
                                    <mat-icon class="material-symbols-outlined" aria-hidden="true">
                                        {{ action.icon }}
                                    </mat-icon>
                                </button>
                            }
                        </span>
                    }
                </div>
            </div>
        }
    </div>
    @if (filteredList().length === 0) {
        <div fxLayoutAlign="center center" class="cipo--height--full">
            <span class="text-muted">{{ "nestedList.noItems" | translate }}</span>
        </div>
    } @else {
        <div fxFlex class="nested-list m-t-md">
            <div
                cdkDropList
                class="nested-list-content"
                [class.nested-box-cursor]="!options()?.disableDragAndDrop"
                (cdkDropListDropped)="drop($event)"
                [cdkDropListConnectedTo]="[connectedListTo()]"
                [cdkDropListDisabled]="options()?.disableDragAndDrop">
                @for (element of filteredList(); track element.uniqueKey) {
                    <div
                        class="nested-box"
                        [class.modified-element]="element.modified || element.markedForDeletion"
                        cdkDrag>
                        <div
                            class="nested-box-content cipo--width--full"
                            fxLayoutAlign="space-between center"
                            fxLayoutGap="8px">
                            <span fxLayoutAlign="start center">
                                @if (leftRowActions()?.length && !element.markedForDeletion) {
                                    <span>
                                        @for (action of leftRowActions(); track $index) {
                                            @if (!action.condition || action.condition(element)) {
                                                <button
                                                    mat-icon-button
                                                    [title]="action.label | translate"
                                                    [attr.aria-label]="action.label | translate"
                                                    (click)="action.action ? action.action(element) : null"
                                                    [matMenuTriggerFor]="
                                                        action.children?.length ? actionsChildren : null
                                                    "
                                                    [matMenuTriggerData]="{ children: action.children }">
                                                    <mat-icon class="material-icons-outlined" aria-hidden="true">
                                                        {{ action.icon }}
                                                    </mat-icon>
                                                </button>
                                            }
                                        }
                                    </span>
                                }
                                <span>{{ element.title }}</span>
                            </span>
                            @if (element.markedForDeletion) {
                                <span class="marked-for-deletion">
                                    {{ "nestedList.markAsDelete" | translate }}
                                </span>
                            }
                            @if (rightRowActions()?.length && !element.markedForDeletion) {
                                <span>
                                    @for (action of rightRowActions(); track $index) {
                                        @if (!action.condition || action.condition(element)) {
                                            <button
                                                mat-icon-button
                                                [title]="action.label | translate"
                                                [attr.aria-label]="action.label | translate"
                                                (click)="action.action ? action.action(element) : null"
                                                [matMenuTriggerFor]="action.children?.length ? actionsChildren : null"
                                                [matMenuTriggerData]="{ children: action.children }">
                                                <mat-icon class="material-icons-outlined" aria-hidden="true">{{ action.icon }}</mat-icon>
                                            </button>
                                        }
                                    }
                                </span>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>

<mat-menu #actionsChildren="matMenu">
    <ng-template matMenuContent let-children="children">
        @for (child of children; track $index) {
            <button mat-menu-item (click)="child.action()">
                @if (child.icon && child.position === "start") {
                    <mat-icon class="material-icons-outlined">{{ child.icon }}</mat-icon>
                }
                {{ child.label | translate }}
                @if (child.icon && child.position === "end") {
                    <mat-icon class="material-icons-outlined">{{ child.icon }}</mat-icon>
                }
            </button>
        }
    </ng-template>
</mat-menu>
